/** Auth form typography helpers — common tokens only, used inside Authentication. */
export const AUTH_LABEL_CLASS =
  'text-h6 font-medium font-sf-pro-display text-text-primary';

export const AUTH_INPUT_CLASS =
  'text-h6-normal placeholder:text-h6-normal placeholder-text-secondary';

export const AUTH_BUTTON_CLASS = 'text-text-h5 text-surface-mint !font-medium';

/** Form / content card — matches LoginForm left panel */
export const AUTH_FORM_CARD_CLASS =
  'w-full max-w-[710px] bg-surface-mist rounded-card p-8 md:p-6 flex flex-col';

export const AUTH_TITLE_CLASS =
  'text-h1 font-normal font-sf-pro-display text-text-primary mb-2';

export const AUTH_SUBTITLE_CLASS =
  'text-body-lg font-normal font-sf-pro-display text-text-secondary mb-8';

/** Back / Back to Login links — 400 weight */
export const AUTH_BACK_CLASS =
  'flex items-center text-text-primary text-body-lg font-normal font-sf-pro-display w-fit transition-colors outline-none focus:outline-none';
